import { getDataWithRetry } from '../fetchUtils';
import { apiBaseUrl } from '../apiConsts';
import { isValidLastSessionsResponse } from '../apiValidators';

import type { TrainingRoutineSession } from '../../types';
import type { FetchResult, FetchSuccess } from '../fetchUtils';

const createSuccessResult = <T>(data: T): FetchSuccess<T> => ({
  success: true,
  data,
  status: 200,
  durationMs: 0,
});

export const fetchLastSessions = async (
  memberIds: string[],
): Promise<FetchResult<Record<string, TrainingRoutineSession>>> => {
  if (!memberIds?.length) {
    return createSuccessResult<Record<string, TrainingRoutineSession>>({});
  }
  const response = await getDataWithRetry<Record<string, TrainingRoutineSession>>(
    `${apiBaseUrl}training-routine-sessions/last-by-members?hoursBack=16`,
    {
      headers: { 'content-type': 'application/json' },
      method: 'POST',
      body: JSON.stringify([...memberIds]),
    },
    isValidLastSessionsResponse,
  );

  if (!response.success) {
    return response;
  }

  return {
    ...response,
    data: response.data ?? {},
  };
};
